<script setup lang="ts">
  import { computed } from 'vue';
  import type { ChatBgShapeConfig } from '@/models/chat';

  const props = defineProps({
    color1: {
      type: String,
      required: true
    },
    color2: {
      type: String,
      required: true
    },
    isChameleonMode: {
      type: Boolean,
      default: false
    }
  });

  const chameleonMode = computed(() => props.isChameleonMode);

  const shapeConfig: ChatBgShapeConfig = {
    initialStart: {
      top: 410.53,
      left: 704.11,
      width: 622.651,
      height: 286.99,
      rotation: 22.087,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    initialEnd: {
      top: 344.12,
      left: 730.16,
      width: 787,
      height: 420.762,
      rotation: -22.006,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    },
    chameleonStart: {
      top: 304.98,
      left: 474.27,
      width: 575.142,
      height: 213.894,
      rotation: -151.589,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    chameleonEnd: {
      top: 168.61,
      left: 503.16,
      width: 787,
      height: 397,
      rotation: -20,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    }
  };

  const { svgRef } = useChatBgShape(chameleonMode, shapeConfig);
</script>

<template>
  <svg
    ref="svgRef"
    :class="['chat-bg-shape', 'chat-bg-shape--3', { chameleon: chameleonMode }]"
    :style="{ '--chat-bg-color-1': color1, '--chat-bg-color-2': color2 }"
    width="623"
    height="288"
    viewBox="0 0 623 288"
    xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="311.435"
      cy="144.028"
      rx="311.325"
      ry="143.495"
      fill="url(#paint0_radial_6_4)" />
    <defs>
      <radialGradient
        id="paint0_radial_6_4"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-162.916 273.151 -3093.83 -260.188 210.958 5.29798)"
        gradientUnits="userSpaceOnUse">
        <stop
          class="color1"
          offset="0" />
        <stop
          class="color2"
          offset="1" />
      </radialGradient>
    </defs>
  </svg>
</template>
